import moment from 'moment'

/**
 * Các hàm tiện ích cho ngày và thời gian.
 */

export const formatDateOrFallback = (value, format, fallback = '-') => {
  if (!value) {
    return fallback
  }

  return moment(value).format(format)
}

export const formatDateWithInputFormat = (value, inputFormat, outputFormat, fallback = '-') => {
  if (!value) {
    return fallback
  }

  const date = moment(String(value), inputFormat, true)
  if (!date.isValid()) {
    return fallback
  }

  return date.format(outputFormat)
}

export const getDatesInMonth = (value, throughToday = false) => {
  const start = moment(value).startOf('month')
  let days = start.daysInMonth()
  if (throughToday && start.isSame(moment(), 'month')) {
    days = moment().date()
  }
  return Array.from({ length: days }, (_, index) => start.clone().add(index, 'days').format('YYYY-MM-DD'))
}

export const parseExcelDate = (value, inputFormats, outputFormat) => {
  let dateValue = value

  if (typeof value === 'number') {
    dateValue = new Date(Math.round((value - 25569) * 86400 * 1000))
  }

  const parsedDate = moment(dateValue, inputFormats, true)
  if (!parsedDate.isValid()) {
    throw new Error('Invalid date')
  }

  return parsedDate.format(outputFormat)
}